import React, { useState } from "react";
import styles from "./DatabaseToggle.module.scss";

function DatabaseToggle(props) {
  const toggleAlpha = props.toggleAlpha;
  const alpha = props.alpha;

  if (alpha === "markers3") {
    return (
      <div>
        <label className={styles.switch}>
          <input type="checkbox" onClick={toggleAlpha} />
          <span className={styles.slider}></span>
        </label>
      </div>
    );
  } else {
    return (
      <div>
        <label className={styles.switch}>
          <input type="checkbox" onClick={toggleAlpha} checked />
          <span className={styles.slider}></span>
        </label>
      </div>
    );
  }
}

export default DatabaseToggle;
